const showImage = (thumbnail, gallery=false, index=0) => {
  if (gallery) {
    const big = gallery.querySelector('.thumb-big');
    big.classList.remove('thumb-big');
    gallery.setAttribute('data-shown', index);
  }
  thumbnail.classList.add('thumb-big');
}
const initGallery = () => {
  document.querySelectorAll('.wp-block-gallery').forEach(gallery => {
    const total = gallery.querySelectorAll('figure:not(.zoom)').length;
    gallery.innerHTML += '<figure class="zoom hidden"><img src=""></figure>';
    if (total > 1) {
      gallery.innerHTML += '<div class="buttons"><button class="prev">Previous</button><button class="next">Next</button></div>';
    }
    const zoom = gallery.querySelector('.zoom');
    zoom.addEventListener('click', () => {
      zoom.classList.add('hidden');
      zoom.querySelector('img').src = '';
    });
    gallery.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const action = (button.className == 'prev') ? -1 : 1;
        const shown = parseInt(gallery.dataset.shown);
        const targetIndex = (shown+action)%total < 0 ? total-1 : (shown+action)%total;        const target = gallery.querySelectorAll('figure:not(.zoom)')[targetIndex];
        showImage(target, gallery, targetIndex);
      });
    });
    gallery.querySelectorAll('figure:not(.zoom)').forEach((thumbnail, index) => {
      if (index == 0) {
        showImage(thumbnail);
        gallery.setAttribute('data-shown',0);
      }
      thumbnail.addEventListener('click', () => {
        if (thumbnail.className.indexOf('thumb-big') >= 0) {
          zoom.classList.remove('hidden');
          zoom.querySelector('img').src = thumbnail.querySelector('img').src;
        } else {
          showImage(thumbnail, gallery, index);
        }
      });
    });
  });
}
export { initGallery }


// WEBPACK FOOTER //
// ./scripts/gallery.js